/** Gap between the marker and the popup base. */
export const BIKE_POPUP_MARGIN_POINT = 20;

/** Default edge margin for map-anchored positioning. */
export const BIKE_POPUP_EDGE_MARGIN_DEFAULT = 10;

/** Estimated chrome above the vehicle list (header, body padding). */
export const BIKE_POPUP_CHROME_HEIGHT_ESTIMATE_PX = 115;

/** Max height (px) of the scrollable vehicle list inside the popup. */
export const BIKE_POPUP_VEHICLE_LIST_MAX_HEIGHT_PX = 200;

/**
 * Fallback total popup height (px) before the first layout measure.
 * Must include the vehicle list max height, not replace it.
 */
export const BIKE_POPUP_FALLBACK_TOTAL_HEIGHT_PX =
    BIKE_POPUP_CHROME_HEIGHT_ESTIMATE_PX + BIKE_POPUP_VEHICLE_LIST_MAX_HEIGHT_PX;

/** Tailwind classes for the popup header. */
export const BIKE_POPUP_HEADER_CLASS_NAME =
    "px-3 py-2.5 font-bold text-sm flex min-h-9 items-center gap-2 min-w-0";

/** Tailwind classes for vehicle type chips and stat cards. */
export const BIKE_POPUP_CHIP_CLASS_NAME =
    "rounded-xl border px-2.5 py-1.5 flex items-center gap-2 min-h-[3.75rem]";

/** Tailwind classes for a vehicle row in the list. */
export const BIKE_POPUP_VEHICLE_ROW_CLASS_NAME =
    "rounded-xl border px-2.5 py-2";

/** Tailwind classes for the top-right icon action button. */
export const BIKE_POPUP_ICON_BUTTON_CLASS_NAME =
    "inline-flex items-center justify-center rounded-full w-8 h-8 border shadow-sm transition-colors duration-150 ease-out active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1";
